import api from './client';

export interface BillingStep {
  label: string;
  abbreviation?: string;
  percentage: number;
  is_demarrage: boolean;
  payment_delay_days?: number;
  project_delay_days?: number;
  step_gap_delay_days?: number;
}

export interface StepMapping {
  step_index: number;
  linked_steps: string[];
}

// mappings keyed by project_template_id
export type BillingMappings = Record<string, StepMapping[]>;

export interface BillingTemplate {
  id: string;
  name: string;
  org_id: string;
  steps: BillingStep[];
  mappings: BillingMappings;
  created_at?: string;
}

export const billingTemplatesApi = {
  list: async (orgId?: string): Promise<BillingTemplate[]> => {
    const { data } = await api.get('/billing-templates', { params: orgId ? { org_id: orgId } : {} });
    return data;
  },

  get: async (templateId: string): Promise<BillingTemplate> => {
    const { data } = await api.get(`/billing-templates/${templateId}`);
    return data;
  },

  create: async (template: Omit<BillingTemplate, 'id' | 'created_at'>): Promise<BillingTemplate> => {
    const { data } = await api.post('/billing-templates', template);
    return data;
  },

  update: async (templateId: string, updates: { name?: string; steps?: BillingStep[]; mappings?: BillingMappings }): Promise<BillingTemplate> => {
    const { data } = await api.patch(`/billing-templates/${templateId}`, updates);
    return data;
  },

  delete: async (templateId: string): Promise<void> => {
    await api.delete(`/billing-templates/${templateId}`);
  },
};
